import gsap from 'gsap'

const Loader = {
  el: {
    loader: document.querySelector<HTMLDivElement>('.page-loader'),
    logo: document.querySelector<HTMLDivElement>('.loader__logo'),
    header: document.querySelector<HTMLDivElement>('.header'),
    top: document.querySelector<HTMLDivElement>('.top'),
    hero: {
      root: document.querySelector<HTMLDivElement>('.hero'),
      left: document.querySelector<HTMLDivElement>('.hero__left'),
      image: document.querySelector<HTMLDivElement>('.hero__image'),
      title: document.querySelector<HTMLDivElement>('.hero__title'),
      text: document.querySelector<HTMLDivElement>('.hero__text'),
      button: document.querySelector<HTMLDivElement>('.hero__button'),
    }
  },
  classes: {
    hide: 'page-cover--hidden',
  },
  init() {
    if (!JSON.parse(window.sessionStorage.getItem('luxorPageLoaded'))) {
      gsap.set(this.el.top, { y: '-100%' })
      gsap.set(this.el.hero.image, { x: -50, opacity: 0 })
      gsap.set(this.el.hero.title, { y: +50, opacity: 0 })
      gsap.set(this.el.hero.text, { y: +50, opacity: 0 })
      gsap.set(this.el.hero.button, { y: +50, opacity: 0 })

      this.animateCover()

      if (this.el.hero.root) {
        this.animateHero()
      }
    } else {
      this.el.loader.classList.add(this.classes.hide)
    }
  },
  animateCover() {
    gsap.to(this.el.logo, { opacity: 1, duration: .5, ease: 'power4.inOut' })
    gsap.to(this.el.loader, {
      delay: 1,
      duration: 1,
      ease: 'power4.inOut',
      x: '100%',
      onComplete: () => {
        this.el.loader.classList.add(this.classes.hide)
        sessionStorage.setItem('luxorPageLoaded', JSON.stringify(true))
      },
    })

    gsap.to(this.el.top, { y: 0, duration: 1.3, delay: 2, ease: 'power4.in' })

  },
  animateHero() {
    gsap.to(this.el.hero.image, { x: 0, opacity: 1, duration: 2, delay: 1.2, ease: 'power4.inOut' })
    gsap.to(this.el.hero.title, { y: 0, opacity: 1, duration: 1.5, delay: 1.9, ease: 'power4.out' })
    gsap.to(this.el.hero.text, { y: 0, opacity: 1, duration: 1.5, delay: 2.1, ease: 'power4.out' })
    gsap.to(this.el.hero.button, { y: 0, opacity: 1, duration: 1.5, delay: 2.2, ease: 'power4.out' })
  },
  start(loader) {
    loader.style.display = 'block'
  },
  reset(loader) {
    loader.style.display = 'none'
  }
}

export default Loader
